let prefix = '/api/indicators';

function getIndicators(){
    return window.axios.get(prefix+'/index');
}
function store(data){
    return window.axios.post(prefix+'/store', data);
}

function update(id, data){
    return window.axios.put(prefix+'/'+id, data);
}
function deleted(id){
    return window.axios.delete(prefix+'/'+id);
}

export default {
    getIndicators,
    store,
    update,
    deleted,    
}